var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.activeUser.admin && _vm.activeUser.site && _vm.activeUser.site.hasDataProcessingConfirmed === false)?_c('div',[_c('data-processing-modal')],1):_c('div',[_c(_vm.currentComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }